<template>
  <td>
    <h6 class="custom-margin-h6-table">
      <strong>{{ $t('common_words.blocks_allotment_relation_2') }}:</strong>
    </h6>
    <span v-for="(names, index) in relations" :key="index">
      <el-tag type="info"
        ><span
          >{{ names }} : {{ infoData.lots_rel[index].join(', ') }}</span
        ></el-tag
      >
    </span>
  </td>
</template>
<script>
export default {
  name: 'td-relations-block-lots',
  props: {
    relations: {
      required: true,
    },
    infoData: {
      type: Object,
      required: true,
    },
  },
};
</script>
